<template>
    <!-- 输入框 包含全部 份额 按钮 -->
    <div class="wk-input wk-input-box wk-input-all">
        <span class="input-left-label">{{labelOver}}</span>
        <div class="posi-relative"> 
            <!-- <p class="posi-absolute bg-white" 
                style="left: .8rem;z-index: 10;top: 10px;font-size: 16px; right:auto;">
                {{inputValFmt}}</p> -->
            <input-base type="money" v-model="inputVal" :initVal="value" ref="inputAllRef"
                :placeholder="placeholderOver" :maxlength="maxlength" @blur="$emit('blur')"/>
            <p class="posi-absolute txt-blue cur-pot" @click="getAllShare" v-if="showAll"> 全部份额 </p>
            <p style="padding-top:.1rem; font-size:.6rem;"> {{inputValStr}}</p>
        </div>
    </div>
    
</template>
 
<script>
    export default {
        name: 'inputlsit',
        props: ['label','placeholder','maxlength','value','showAll'],
        mounted(){
            this.labelOver = this.label;
            this.labelOver ? this.placeholderOver = '请输入' + this.labelOver : '';
            this.placeholder ? this.placeholderOver = this.placeholder : '';
        },
        data(){
            return{
                inputVal:'',
                inputValStr:'',
                inputValFmt:'',
                labelOver:'',
                placeholderOver:'请输入赎回份额'
            }
        },    
        watch:{
            inputVal(newVal){
                this.inputValStr = this.$tools.Arabia_To_Chinese(this.inputVal);
                this.inputValFmt = this.format(this.inputVal);
                this.$emit('input',this.inputVal)
            },
            value(){
                this.inputValStr = this.$tools.Arabia_To_Chinese(this.inputVal);
                this.inputValFmt = this.format(this.inputVal);
                this.$refs.inputAllRef.setValue(this.value);
            },
            placeholder(){
                this.placeholderOver = this.placeholder;
            }
        },
		methods: {
            setValue(val){
                this.$refs.inputAllRef.setValue(val);
            },
            getAllShare(){
                this.$emit('getAllShare');
            },
            format (num) {
                return (num+ '').replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g,'$1,');
            }
		}
    }
</script>
<style lang="less" scoped>
    .wk-input{
        >div{
            // 全部份额
            >p.posi-absolute{
                top:.6rem;
                right:1.4rem;
            }
        }
    }
    .wk-input + .wk-input{
        margin-top:.9rem;
    }
</style>
<style lang="less">
    // .wk-input-all{
    //     img{
    //         right:4.1rem !important;
    //     }
    // }
</style>



// WEBPACK FOOTER //
// src/components/BaseCpts/wkInputAll.vue